import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { AssignWorkInfoDaySearchParam } from '../../models/gen/assignWorkInfoDaySearchParam';
import { AssignWorkInfoDaySearchResult } from '../../models/gen/assignWorkInfoDaySearchResult';
import { AssignWorkInfoSaveParam } from '../../models/gen/assignWorkInfoSaveParam';
import { AssignWorkInfoSearchParam } from '../../models/gen/assignWorkInfoSearchParam';
import { AssignWorkInfoSearchResult } from '../../models/gen/assignWorkInfoSearchResult';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const ASSIGN_WORK_INFO_CONTEXT_NAMES = {
  POST_ASSIGN_WORK_INFO: 'saveAssignWorkInfo',
  POST_ASSIGN_WORK_INFO_SEARCH: 'searchAssignWorkInfo',
  POST_ASSIGN_WORK_INFO_DAY_SEARCH: 'searchAssignWorkInfoDay',
} as const;

const apis = apiGenerator();

/**
 * POST `/assign-work-info`
 *
 * @param param -
 * @returns
 */
export const usePostAssignWorkInfo = () =>
  useGenericMutation(async (param: AssignWorkInfoSaveParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/assign-work-info`, {
      ...queryOptions,
      data: param,
    })
  );

/**
 * POST `/assign-work-info/search`
 *
 * @param param -
 * @returns
 */
export const usePostAssignWorkInfoSearch = (param: AssignWorkInfoSearchParam) =>
  useGenericQuery(
    [
      ASSIGN_WORK_INFO_CONTEXT_NAMES.POST_ASSIGN_WORK_INFO_SEARCH,
      param as Record<string, unknown>,
    ],
    async (_param) =>
      apis.post<AssignWorkInfoSearchParam, AssignWorkInfoSearchResult>(
        `${env.BASE_API_ENDPOINT}/assign-work-info/search`,
        { ...queryOptions, data: param }
      )
  );

/**
 * POST `/assign-work-info/day/search`
 *
 * @param param -
 * @returns
 */
export const usePostAssignWorkInfoDaySearch = (
  param: AssignWorkInfoDaySearchParam
) =>
  useGenericQuery(
    [
      ASSIGN_WORK_INFO_CONTEXT_NAMES.POST_ASSIGN_WORK_INFO_DAY_SEARCH,
      param as any,
    ],
    async (_param) =>
      apis.post<AssignWorkInfoDaySearchParam, AssignWorkInfoDaySearchResult>(
        `${env.BASE_API_ENDPOINT}/assign-work-info/day/search`,
        { ...queryOptions, data: param }
      ),
    {
      enabled: false,
    }
  );
